import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import DashLayout from '../../components/DashLayout';

const nav = [
  { to: '/agent',         icon: '💬', label: 'Live Chats' },
  { to: '/agent/leads',   icon: '👥', label: 'Leads' },
  { to: '/agent/crm',     icon: '📋', label: 'CRM' },
  { to: '/agent/profile', icon: '👤', label: 'My Profile' },
];

export default function AgentChats() {
  const [chats, setChats] = useState([]);
  const [filter, setFilter] = useState('open');
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`/api/chats?status=${filter}`).then(r => setChats(r.data.data || [])).catch(() => {});
  }, [filter]);

  return (
    <DashLayout navItems={nav} role="Agent">
      <div style={{ padding: 28 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>My Chats</h1>
        <p style={{ color: '#555', fontSize: 13, marginBottom: 24 }}>View and manage all your chat conversations</p>

        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          {['open', 'active', 'resolved', 'missed'].map(s => (
            <button key={s} onClick={() => setFilter(s)} style={{ padding: '7px 16px', borderRadius: 8, border: `1px solid ${filter === s ? '#00d55b' : '#1e1e1e'}`, background: filter === s ? 'rgba(0,213,91,0.1)' : 'transparent', color: filter === s ? '#00d55b' : '#555', fontSize: 13, cursor: 'pointer', textTransform: 'capitalize' }}>
              {s}
            </button>
          ))}
        </div>

        <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, overflow: 'hidden' }}>
          {chats.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#333', fontSize: 13 }}>No {filter} chats</div>
          ) : chats.map(chat => (
            <div key={chat.id} onClick={() => navigate('/agent')} style={{ padding: '14px 20px', borderBottom: '1px solid #0d0d0d', display: 'flex', gap: 14, alignItems: 'center', cursor: 'pointer' }}
              onMouseEnter={e => e.currentTarget.style.background = '#0d0d0d'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 600, color: '#00d55b', flexShrink: 0 }}>
                {chat.visitor_name?.[0]?.toUpperCase() || '?'}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 14, fontWeight: 500 }}>{chat.visitor_name || 'Visitor'}</span>
                  <span style={{ fontSize: 11, color: '#555' }}>{new Date(chat.started_at).toLocaleString()}</span>
                </div>
                <div style={{ fontSize: 12, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{chat.last_message || 'No messages'}</div>
                <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                  <span style={{ fontSize: 10, color: '#555' }}>{chat.city}, {chat.country}</span>
                  <span style={{ fontSize: 10, color: '#555' }}>·</span>
                  <span style={{ fontSize: 10, color: '#555' }}>{chat.device_type}</span>
                  {chat.unread_count > 0 && <span style={{ background: '#00d55b', color: '#000', fontSize: 10, padding: '0px 6px', borderRadius: 10, fontWeight: 700 }}>{chat.unread_count} new</span>}
                </div>
              </div>
              <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 20, background: chat.status === 'resolved' ? 'rgba(0,213,91,0.1)' : chat.status === 'open' ? 'rgba(245,158,11,0.1)' : '#1a1a1a', color: chat.status === 'resolved' ? '#00d55b' : chat.status === 'open' ? '#f59e0b' : '#555', flexShrink: 0 }}>
                {chat.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </DashLayout>
  );
}